import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/loading-wrapper";
import { LineChart, StackedBarChart, DiscreteColorLegend, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { colorScaleCategorical } from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { removeOutlierByPercentile } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import { withChartConfig } from "../../common/chart-config-hoc";

import { getDocumentsByDate, getDocumentsByDateAndField } from "../../../services/api-repo";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";

const colorScale = colorScaleCategorical();

const COLOR_MAP = {
  "802.11": Colors.blue500,
  "802.15": Colors.blue300,
  "802.16": Colors.blue100,
  "802.18": Colors.orange500,
  "802.19": Colors.orange300,
  "802.21": Colors.orange100,
  "802.22": Colors.grey500,
  "802.23": Colors.grey300,
  "802.24": Colors.grey100,
  avc: Colors.grey500,
  hevc: Colors.orange500,
  vvc: Colors.blue500
};

class DateHistogram extends Component {
  static propTypes = {
    field: PropTypes.string.isRequired,
    field2: PropTypes.string,
    filter: PropTypes.object,
    esUrl: PropTypes.string.isRequired,
    chartType: PropTypes.oneOf(["LineChart", "StackedBarChart"]),
    axisTypeX: PropTypes.oneOf(["ordinal", "linear", "time"])
  };

  static defaultProps = {
    filter: {},
    chartType: "StackedBarChart",
    axisTypeX: "ordinal"
  };

  state = {
    data: [],
    dataRaw: [], // for csv export
    loading: true
  };

  componentDidMount() {
    this._isMounted = true;
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { loading } = this.state;
    const { field2 } = this.props;
    return (
      <LoadingWrapper loading={loading} spinSize="large" style={{ minHeight: 400, textAlign: "center" }}>
        {this._renderChart()}
        {field2 ? this._renderLegend() : null}
      </LoadingWrapper>
    );
  }

  _renderChart = () => {
    const { data } = this.state;
    const { axisTypeX } = this.props;
    const chart = this.props.chartType === "StackedBarChart" ? StackedBarChart : LineChart;
    const FlexibleChart = withChartConfig(makeWidthFlexible(chart));
    return <FlexibleChart data={data} height={500} tickLabelAngleX={-30} tickFormatX={v => v} colorMap={COLOR_MAP} axisTypeX={axisTypeX} />;
  };

  _renderLegend = () => {
    const field2Keys = this.state.data.map(d => d.k);
    return field2Keys.length > 0 && <DiscreteColorLegend orientation="horizontal" items={field2Keys.map(key => ({ title: key, color: COLOR_MAP[key] }))} colors={[...field2Keys].map(colorScale)} />;
  };

  _getData = props => {
    if (this._isMounted) this.setState({ loading: true });
    const { field2, field, filter, esUrl } = props;
    const apiCallPromise = field2 ? getDocumentsByDateAndField(esUrl, filter, field, field2) : getDocumentsByDate(esUrl, filter, field);
    apiCallPromise
      .then(res => {
        if (this._isMounted)
          this.setState({
            data: this._reformatData(res),
            dataRaw: res,
            loading: false
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            data: [],
            dataRaw: [],
            loading: false
          });
      });
  };

  _reformatData = data => {
    const { field2 } = this.props;
    const toLabel = ts => {
      const d = new Date(ts);
      return `${d.getUTCFullYear()}`;
    };
    if (field2) {
      const formatedData = data.map(e => ({ k: e.key, v: e.value.map(e2 => ({ k: e2.key, v: e2.doc_count })) }));
      const res = {};
      formatedData.forEach(e => {
        e.v.forEach(e2 => {
          if (!res[e2.k]) res[e2.k] = [];
          res[e2.k].push({ k: toLabel(e.k), v: e2.v });
        });
      });
      const resSeries = Object.entries(res).map(([k, v]) => ({ k, v }));
      return removeOutlierByPercentile(resSeries, 99);
    } else {
      const formattedData = data.map(e => ({ k: toLabel(e.key), v: e.doc_count }));
      return formattedData.length == 0 ? [] : [{ k: "Count", v: removeOutlierByPercentile(formattedData, 99) }];
    }
  };
}

export default DateHistogram;
